import { render, staticRenderFns } from "./OrderForm.vue?vue&type=template&id=230fca03&scoped=true"
import script from "./OrderForm.vue?vue&type=script&lang=js"
export * from "./OrderForm.vue?vue&type=script&lang=js"
import style0 from "./OrderForm.vue?vue&type=style&index=0&id=230fca03&prod&scoped=true&lang=css"
import style1 from "./OrderForm.vue?vue&type=style&index=1&id=230fca03&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230fca03",
  null
  
)

export default component.exports